export default __webpack_public_path__ + "static/cloud-9ff4f1520bdecf294725cc1f567dcdf0.png";